import { defineLanguage } from '../../../src/domain/language/factory';

export default defineLanguage({
  languageName: 'Arabic',
  languageCode: 'ar',
  languageHeaderCode: 'ar',
});
